// removed by extract-text-webpack-plugin
module.exports = {"container":"index_2bkslLt","main_block":"index_2J2yZo8","side_block":"index_2uY9iSD","side":"index_STXzPco index_2uY9iSD","button":"index_3HLv6G7","number":"index_3Hyx5i1","chapter":"index_3mWK_3u","no_comments":"index_3oa7B5c","summary":"index_12f5xMh","right_menu":"index_rNmqd9J"};


//////////////////
// WEBPACK FOOTER
// ./src/layout/book/detail/index.css
// module id = 259
// module chunks = 0